import React, { useState, useMemo, useEffect } from "react"
import { Button, Form } from "react-bootstrap"
import _get from "lodash/get"
import useNewsVote from "./context"
import { Divider } from "semantic-ui-react"
import { FormInput } from "../../widgets/Form"
import DateTime from "@nateradebaugh/react-datetime"
import moment from "moment"
import { SectionStyled } from "../../styled"

const PrizeAnnounce = () => {
	const { data, handleChange, handleSavePrize, isLoadingSave } = useNewsVote()
	const [prizeSelected, setPrizeSelected] = useState(0)
	const [statusSave, setStatusSave] = useState(null)
	const prize = useMemo(() => _get(data, `prize.items[${prizeSelected}]`, {}), [data, prizeSelected])
	const isOverMemberLimit = useMemo(() => {
		const members = _get(data, `prize.items[${prizeSelected}].members`, [])
		return members.length > prize.amount
	}, [data, prizeSelected, prize])

	const handleAddMember = () => {
		const members = _get(data, `prize.items[${prizeSelected}].members`, [])
		// default announceAt to today's date 08.30 AM
		const newMembers = [...members, { name: "", phone: "", announceAt: moment().set({ hour: 8, minute: 30, second: 0, millisecond: 0 }).toDate() }]
		handleChange({ name: `prize.items[${prizeSelected}].members`, value: newMembers })
	}

	const handleSave = async () => {
		const { success } = await handleSavePrize()
		setStatusSave(success ? "success" : "error")
		setTimeout(() => {
			setStatusSave(null)
		}, 1000)
	}

	const handleDeleteMember = (index) => {
		const members = _get(data, `prize.items[${prizeSelected}].members`, [])
		const newMembers = members.filter((_, i) => i !== index)
		handleChange({ name: `prize.items[${prizeSelected}].members`, value: newMembers })
	}

	return (
		<div>
			<div
				style={{
					display: "flex",
					overflowX: "auto",
					padding: "0.5rem",
				}}
			>
				{_get(data, "prize.items", []).map((item, index) => (
					<Button
						key={item.key}
						onClick={() => setPrizeSelected(index)}
						variant={prizeSelected === index ? "dark" : "outline-dark"}
						style={{
							marginRight: "0.5rem",
							whiteSpace: "nowrap",
						}}
					>{`รางวัลที่ ${index + 1}`}</Button>
				))}
			</div>
			<Divider />
			<Button onClick={handleSave} className="mb-2" variant={"success"} disabled={isLoadingSave}>
				{isLoadingSave ? "กำลังบันทึก..." : "บันทึกข้อมูล"}
			</Button>
			{statusSave === "success" && <span className="text-success ml-2">บันทึกข้อมูลสำเร็จ</span>}
			{statusSave === "error" && <span className="text-danger ml-2">บันทึกข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง</span>}
			<div className="row ml-1">
				<SectionStyled key={`prize-data-${prizeSelected}`} className="col-12 col-xl-8">
					<div className="row">
						<div className="col-12 col-xl-12 d-flex mb-4">
							<div className="px-4">
								<h5 className="font-weight-bold">{prize?.title}</h5>
								<h6>
									จำนวน <span className="text-primary">{prize?.amount}</span> รางวัล
								</h6>
								{isOverMemberLimit && <h6 className="text-danger">จำนวนรายชื่อผู้ได้รับรางวัลมากกว่าจำนวนรางวัลที่กำหนดกรุณาลบข้อมูล</h6>}
							</div>
						</div>

						<div className="col-12 col-xl-12">
							<div className="d-flex justify-content-between align-items-center mb-3">
								<h6 className="font-weight-bold mb-0">รายชื่อผู้ได้รับรางวัล</h6>
								<span className="text-muted" style={{ fontSize: "80%" }}>
									กรอกข้อมูลตามจำนวน {prize?.amount || 0} รางวัล
								</span>
							</div>
							{(prize.members || []).length === 0 ? (
								<div className="text-muted"></div>
							) : (
								prize.members.map((member, index) => (
									<div key={`member-${prizeSelected}-${index}`} className="border rounded p-3 mb-3">
										<div className="d-flex justify-content-between align-items-center mb-3">
											<h6 className="mb-0">
												ผู้ได้รับรางวัลที่ <span className="text-primary">{index + 1}</span>
											</h6>

											<Button variant="outline-danger" size="sm" onClick={() => handleDeleteMember(index)}>
												ลบผู้ได้รับรางวัล
											</Button>
										</div>
										<div className="row">
											<div className="col-12 col-md-4 mb-3">
												<FormInput
													name={`prize.items[${prizeSelected}].members[${index}].announceAt`}
													label="วันที่ประกาศ"
													required={true}
													renderInput={() => (
														<DateTime
															dateFormat={"DD-MM-YYYY"}
															timeFormat={false}
															className="w-100"
															defaultValue={member.announceAt ? moment(member.announceAt).toDate() : ""}
															onBlur={(value) => {
																handleChange({
																	name: `prize.items[${prizeSelected}].members[${index}].announceAt`,
																	value: value && moment(value).isValid() ? moment(value).set({ hour: 8, minute: 30, second: 0, millisecond: 0 }).toDate() : null,
																})
															}}
															inputProps={{ readOnly: true, placeholder: "เลือกวันที่" }}
														/>
													)}
												/>
											</div>
											<div className="col-12 col-md-4 mb-3">
												<FormInput
													name={`prize.items[${prizeSelected}].members[${index}].name`}
													label="ชื่อ - นามสกุล"
													required
													renderInput={(inputProps) => (
														<input
															{...inputProps}
															type="text"
															value={member.name}
															onChange={(e) => {
																handleChange({ name: `prize.items[${prizeSelected}].members[${index}].name`, value: e.target.value })
															}}
														/>
													)}
												/>
											</div>
											<div className="col-12 col-md-4 mb-3">
												<FormInput
													name={`prize.items[${prizeSelected}].members[${index}].phone`}
													label="เบอร์โทรศัพท์"
													required={true}
													renderInput={(inputProps) => (
														<input
															{...inputProps}
															type="tel"
															value={member.phone}
															onChange={(e) => {
																handleChange({ name: `prize.items[${prizeSelected}].members[${index}].phone`, value: e.target.value })
															}}
														/>
													)}
												/>
											</div>
										</div>
									</div>
								))
							)}
							{(prize.members || []).length < prize.amount && (
								<Button
									variant="primary"
									className="w-100"
									onClick={() => {
										handleAddMember()
									}}
								>
									เพิ่มผู้ได้รับรางวัล
								</Button>
							)}
						</div>
					</div>
				</SectionStyled>
			</div>
		</div>
	)
}

export default PrizeAnnounce
